import React, { useCallback, useMemo } from "react";
import WorkflowAgentChat from "./WorkflowAgentChat";
import { useContextAgent } from "../../contextAgent/ContextAgentContext";
import useRegisterContextAgent from "../../contextAgent/useRegisterContextAgent";

/**
 * Registers the workflow-scoped agent with the app-level context rail and panel host.
 */
export default function useWorkflowContextAgent({
  enabled,
  projectId,
  projectName,
  reactFlowInstance,
  initialPrompt,
  initialTemplateId,
  onWorkflowNameChange,
  initialOpen = false,
}) {
  const { setOpen } = useContextAgent();

  const handleClose = useCallback(() => {
    setOpen(false);
  }, [setOpen]);

  const panel = useMemo(
    () =>
      enabled && projectId ? (
        <WorkflowAgentChat
          key={projectId}
          projectId={projectId}
          projectName={projectName}
          onClose={handleClose}
          reactFlowInstance={reactFlowInstance}
          initialPrompt={initialPrompt}
          initialTemplateId={initialTemplateId}
          onWorkflowNameChange={onWorkflowNameChange}
        />
      ) : null,
    [
      enabled,
      projectId,
      projectName,
      handleClose,
      reactFlowInstance,
      initialPrompt,
      initialTemplateId,
      onWorkflowNameChange,
    ]
  );

  const { open: aiChatOpen, setOpen: setAiChatOpen } = useRegisterContextAgent({
    enabled: Boolean(enabled && projectId),
    agentName: "Workflow Operator",
    scopeLabel: projectName,
    scopeId: projectId,
    initialOpen,
    panel,
  });

  return { aiChatOpen, setAiChatOpen };
}
